import React from 'react'
import './about.css'
import lev from './leverage.gif';
export default function About() {
  return (

    <div className=" flex justify-center items-center">
    
   
    <img src={lev} alt="Lev" />

  </div>
  

  )
}
